import { render, staticRenderFns } from "./dongjiang.vue?vue&type=template&id=2d053f74&scoped=true&"
import script from "./dongjiang.vue?vue&type=script&lang=js&"
export * from "./dongjiang.vue?vue&type=script&lang=js&"
import style0 from "./dongjiang.vue?vue&type=style&index=0&id=2d053f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d053f74",
  null
  
)

export default component.exports